export default function PayslipAccess() {
  return <h1>Payslip Access</h1>;
}
